// Amplify
import { API } from 'aws-amplify';

export const createCheckoutSession = async (amount, type, currency) => {
    const apiName = 'stripe';
    const path = '/create-checkout-session';
    
    const myInit = {
        body: {
            donationType: type,
            amount: amount * 100,
            currency: currency
        },
        headers: {
            'Content-Type': 'application/json'
        },
        response: true
    };
    
    try {
        const response = await API.post(apiName, path, myInit);
        return response;
    } catch(e) {
        throw new Error(e);
    }
}